<template>
    <Popup ref="popup" :animation="'scale'" :shadowOpacity="0.8" @ontransitionend="onTransitionEnd" >
        <div class="user-id-tutorial" :style="boxStyle" >
            <div class="scale-cont" :style="contStyle" >
                <img class="bg" :src="_global.assetsRoot + '/user_id_tutorial_bg.png'" />
                <img class="abs-el title" :src="_global.assetsRoot + `/tutorial_title_${_i18n.locale}.png`" />
                <img class="abs-el close btn" :src="_global.assetsRoot + `/tutorial_close.png`" @click="hide" />
                <div class="abs-el steps step1" >
                    <img class="v-m" :src="_global.assetsRoot + '/step1.png'" />
                    <span class="v-m segoe" >{{ $t("message.tutorialStep1") }}</span>
                </div>
                <div class="abs-el steps step2" >
                    <img class="v-m" :src="_global.assetsRoot + '/step2.png'" />
                    <span class="v-m segoe" >{{ $t("message.tutorialStep2") }}</span>
                </div>
                <div class="abs-el btn close-btn" @click="hide" >
                    <span class="v-m segoe" >{{ $t("message.tutorialClose") }}</span>
                </div>
            </div>
        </div>
    </Popup>
</template>

<script>
import Popup from '../Popup.vue'
export default {
    data() {
        return {
            isShow: false,
            scale: 1
        }
    },
    created() {
        this.scale = Math.min(document.body.offsetWidth / 980, document.body.offsetHeight / 1524);// 0.8
    },
    computed: {
        boxStyle() { return `width: ${784 * this.scale}px;height: ${1220 * this.scale}px;` },
        contStyle() { return `transform: scale(${this.scale * 0.8});-webkit-transform: scale(${this.scale * 0.8})` }
    },
    methods: {
        show() { this.isShow = true,this.$refs.popup.show() },
        hide() { this.isShow = false,this.$refs.popup.hide() },
        onTransitionEnd() {
            if (!this.isShow) {
                this.$emit("closed")
            }
        },
    },
    components: { Popup }
}
</script>

<style lang="scss" >
@import "../../assets/css/variables.scss";
.user-id-tutorial {
    margin: 0 auto;

    .scale-cont {
        position: relative;
        width: 980px;
        height: 1524px;
        transform-origin: 0 0;

        .bg {
            width: 100%;
            height: 100%;
        }

        .abs-el {
            position: absolute;
        }

        .title {
            left: 296px;
            top: 104px;
        }

        .close {
            left: 895px;
            top: 216px;
        }

        .steps {
            width: 900px;
            text-align: left;

            img {
                height: 36px;
                margin-right: 1rem;
            }

            span {
                color: #FFF;
                font-size: 28px;
                line-height: 36px;
            }
        }

        .step1 {
            left: 36px;
            top: 762px;
        }

        .step2 {
            left: 36px;
            top: 1274px;
        }

        .close-btn {
            left: 296px;
            top: 1373px;
            width: 428px;
            height: 132px;
            background: url($assetRoot + "/close_btn.png") center no-repeat;
            background-size: 100% 100%;

            span {
                font-size: 42px;
                line-height: 120px;
                color: #FFF;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/popup/FirstLogin.vue